import { LogOut } from 'lucide-react';
import { auth } from '../utils/httpClient';

export default function LogoutButton({ all = false, className = '' }: { all?: boolean; className?: string }) {

    return (
        <button onClick={()=>auth.logout()} className="flex items-center w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50">
            <LogOut size={18} className="mr-2" />
            Sign Out
        </button>
    );
}
